export const DEFAULT_ROW_HEIGHT = 55;
export const CELL_DEFAULT_WIDTH = 60;
export const ROW_BOTTOM_BORDER_HEIGHT = 2;

export const DEFAULT_COLUMN = {
  minWidth: 50,
  width: 'auto',
};
